import { render, staticRenderFns } from "./TableDetails.vue?vue&type=template&id=7d90f65b&scoped=true&"
import script from "./TableDetails.vue?vue&type=script&lang=js&"
export * from "./TableDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d90f65b",
  null
  
)

export default component.exports